@let isActiveValue = isActive();
<span [class]="`${isActiveValue ? 'positive-color' : 'negative-color'}`">{{
  (isActiveValue ? 'ACTIVE' : 'INACTIVE') | i18nPrefixConcat: i18nPrefix | transloco
}}</span>
